import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'reflexbox';
import Text from 'components/Text';
import ProductID from './ProductID';
import StoreLocation from './StoreLocation';
import CollectedCheckbox from './CollectedCheckbox';

import './productPackages.styles.scss';

export default class ProductPackages extends Component {
    renderMultiplePackages() {
        const { productId, productQuantity, parts, showChildren, partsStock, triggerUpdatePartCollected } = this.props;

        if (!showChildren) {
            return null;
        }

        if (partsStock) {
            // Convert to array if API returned it as object
            if (!(partsStock.RetailItemCommChildAvailability instanceof Array)) {
                partsStock.RetailItemCommChildAvailability = [partsStock.RetailItemCommChildAvailability];
            }
        }

        const partComponents = [];

        for (const part of parts) {
            const id = part.ItemNo.$.toString().match(/\d{1,3}/g).join('.');
            const collectedCheckbox = <CollectedCheckbox id={`${productId}-${part.ItemNo.$}-collected`} checked={part.collected} onChange={triggerUpdatePartCollected.bind(this, part, productId)} />;
            let location = <div className="product__package-location"><Text textKey="product_location_no_info" /></div>;

            if (partsStock) {
                const currentPartStock = Object
                    .keys(partsStock.RetailItemCommChildAvailability)
                    .filter(key => partsStock.RetailItemCommChildAvailability[key].ItemNo.$.toString() === part.ItemNo.$.toString())
                    .reduce((result, current) => {
                        return partsStock.RetailItemCommChildAvailability[current];
                    }, {});

                if (currentPartStock.RecommendedSalesLocation.$) {
                    if (currentPartStock.RecommendedSalesLocation.$.toString().match(/^\d+$/)) {
                        const locationData = currentPartStock.RecommendedSalesLocation.$.toString().match(/.{1,2}/g);
                        location = <StoreLocation aisle={locationData[0]} bin={locationData[1]} />;
                    } else {
                        location = <div className="product__package-location">
                            <Text textKey="product_location_collect_from" />
                            <br/>
                            <b>{currentPartStock.RecommendedSalesLocation.$}</b>
                        </div>;
                    }
                }
            }

            partComponents.push(
                <Flex key={`${productId}-${part.ItemNo.$}-collected`} className={`product__package ${part.collected ? 'product__package-collected' : ''}`} justify="space-between" align="flex-end" pt={[1, 2]}>
                    <Box flex={[false, true]} w={1}>
                        <Flex className="product__package-name" auto={[false, true]} wrap align="center">
                            <h4>{part.Quantity.$ * productQuantity}× {part.ProductName.$}</h4>
                            <p>{part.ProductTypeName.$}</p>
                        </Flex>
                        <Flex className="product__location" align="center" justify={[part.collected ? 'space-between' : 'flex-start', 'flex-start']}>
                            <ProductID id={id} />
                            {location}
                        </Flex>
                    </Box>
                    {collectedCheckbox}
                </Flex>
            );
        }

        return (
            <>
                <h3 className="product__package-header">
                    <span><Text textKey="product_parts_header" /></span>
                </h3>
                {partComponents}
            </>
        );
    }

    renderSinglePackage() {
        const { product, productId, productAvailability, articleNumberFormatted, triggerUpdateProductCollected } = this.props;

        let location = <div className="product__package-location"><Text textKey="product_location_no_info" /></div>;

        if (productAvailability?.RecommendedSalesLocation?.$) {
            if (productAvailability.RecommendedSalesLocation.$.toString().match(/^\d+$/)) {
                const locationData = productAvailability.RecommendedSalesLocation.$.toString().match(/.{1,2}/g);
                location = <StoreLocation aisle={locationData[0]} bin={locationData[1]} />;
            } else {
                location = <div className="product__package-location">
                    <Text textKey="product_location_collect_from" />
                    <br />
                    <b>{productAvailability.RecommendedSalesLocation.$}</b>
                </div>;
            }
        }

        return (
            <Flex
                className={`product__package ${product.collected ? 'product__package-collected' : ''}`}
                justify="space-between"
                align="center"
            >
                <Flex w={1}>
                    <ProductID id={articleNumberFormatted} />
                    {location}
                </Flex>
                <CollectedCheckbox id={`${productId}-collected`} checked={product.collected} onChange={triggerUpdateProductCollected.bind(this, product, productId)} />
            </Flex>
        );
    }

    render() {
        const { store, parts } = this.props;

        if (!store || store === '0') {
            return null;
        }

        if (parts) {
            return this.renderMultiplePackages();
        }

        return this.renderSinglePackage();
    }
}

ProductPackages.propTypes = {
    productId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    product: PropTypes.object,
    productQuantity: PropTypes.number.isRequired,
    parts: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]).isRequired,
    partsStock: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool,
    ]).isRequired,
    store: PropTypes.string.isRequired,
    showChildren: PropTypes.bool.isRequired,
    lists: PropTypes.object,
    triggerUpdatePartCollected: PropTypes.func,
    triggerUpdateProductCollected: PropTypes.func,
    updatePartCollected: PropTypes.func,
    updateProductCollected: PropTypes.func,
    productAvailability: PropTypes.object,
    articleNumberFormatted: PropTypes.string,
};
